import { Component, Input } from '@angular/core';
import { FilterInput } from '../../../interfaces/filter-input.interface';
import { FilterOutput } from '../../../interfaces/filter-outpt.interface';
import { FilterSet } from '../../../interfaces/filter-set.interface';
import { FiltersService } from '../../../services/filters/filters.service';
import { takeUntil } from 'rxjs/operators';
import { DisplayFunctions } from '../../../utils/display-functions.class';

@Component({
  selector: 'sellions-layout-renderer-active-filter-list',
  templateUrl: 'active-filter-list.html',
})
export class ActiveFilterListComponent {
  @Input() filterSetName: string;
  public filters: ActiveFilter[] = [];

  constructor(private filtersService: FiltersService) {}

  ngOnInit() {
    this.filtersService.getFilters(this.filterSetName)
      .then(filterSet => {
        this.parseFilterSet(filterSet);
        this.filtersService.filterSetSubject$.subscribe(
          (filterSet: FilterSet) => {
            this.parseFilterSet(filterSet);
          },
          (error) => console.error(error),
        );
      })
  }

  private parseFilterSet(filterSet: FilterSet) {
    if (filterSet && filterSet.name === this.filterSetName && filterSet.filterConfig && filterSet.filterConfig.filters && filterSet.filterConfig.filters.length > 0) {
      this.filters = filterSet.filters.map((filter: FilterOutput) => {
        const f = filterSet.filterConfig.filters.find((element: FilterInput) => element.column === filter.column);
        let value = filter.value
        if(filter.type === 'DATE') {
          value = DisplayFunctions.formatDateDDMMYYYY(value);
        }
        return { label: f.label, value: value, column: filter.column };
      });
    }
  }

  clear(filterToRemove: ActiveFilter): void {
    this.filtersService.getFilters(this.filterSetName).then((filterSet) => {
      this.removeFilter(filterToRemove, filterSet.filters);
      this.removeRedudantOrProperty(filterToRemove.column, filterSet.filters);
      this.filtersService.applyFilters(this.filterSetName, filterSet.filters);
    });
  }

  private removeFilter(filterToRemove: ActiveFilter, filters: FilterOutput[]): void {
    const indexToRemove = filters.findIndex((filter) => filter.column === filterToRemove.column && filter.value === filterToRemove.value);
    filters.splice(indexToRemove, 1);
  }

  private removeRedudantOrProperty(column: string, filters: FilterOutput[]): void {
    const filtersWithColumn = filters.filter((f) => f.column === column);
    if (filtersWithColumn.length === 1) {
      filtersWithColumn[0].queryValue.or = false;
    }
  }
}

export interface ActiveFilter {
  label: string;
  value: string;
  column: string;
}



// WEBPACK FOOTER //
// ./src/submodules/sellions_layout_renderer/projects/sellions-layout-renderer-lib/src/lib/components/filters/active-filter-list/active-filter-list.ts